/** Kinds of partner the /partners form accepts. Stored as is in `venue_partners.partner_type`, whose CHECK constraint allows only these keys. */
export type PartnerType = "hotel_venue" | "cvb_dmo" | "dmc" | "hotel_group" | "other";

/** Wording that changes with the partner type. */
export interface PartnerTypeCopy {
  /** Option text in the "What best describes you?" dropdown. */
  label: string;
  /** Word in front of "name" and "website", e.g. "Company" gives "Company name". */
  noun: string;
  namePlaceholder: string;
  websitePlaceholder: string;
}

/** Wording for each partner type. */
export const PARTNER_TYPE_COPY: Record<PartnerType, PartnerTypeCopy> = {
  hotel_venue: {
    label: "Hotel/venue",
    noun: "Hotel",
    namePlaceholder: "The Grand Hotel",
    websitePlaceholder: "grandhotel.com",
  },
  cvb_dmo: {
    label: "CVB/DMO",
    noun: "Organization",
    namePlaceholder: "Visit Springfield",
    websitePlaceholder: "visitspringfield.com",
  },
  dmc: {
    label: "DMC",
    noun: "Company",
    namePlaceholder: "Acme DMC",
    websitePlaceholder: "acmedmc.com",
  },
  hotel_group: {
    label: "Hotel group/chain",
    noun: "Group",
    namePlaceholder: "Grand Hotels Group",
    websitePlaceholder: "grandhotels.com",
  },
  other: {
    label: "Other",
    noun: "Organization",
    namePlaceholder: "Acme Events",
    websitePlaceholder: "acmeevents.com",
  },
};

/** Dropdown options in display order. */
export const PARTNER_TYPE_OPTIONS: Array<{ value: PartnerType; label: string }> = (
  Object.keys(PARTNER_TYPE_COPY) as PartnerType[]
).map((value) => ({ value, label: PARTNER_TYPE_COPY[value].label }));
